<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks
        v-if="quick_links.length > 0"
        :quick_links="quick_links"
      ></QuickSideLinks>
      <v-divider class="mt-4" v-if="quick_links.length > 0"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="false">
      <CenterSearchForm
        :has_nav_bar="false"
        :width_class="page_info.center_width_class"
        :show_pagination="true"
        :disabled="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
        @on-render-results="on_render_results"
        @on-has-no-search-query="on_has_no_search_query"
      ></CenterSearchForm>
      <div
        class="componet-has-search-bar-with-pagination white"
        id="top_of_results"
      >
        &nbsp;
      </div>
      <CardedDisplay>
        <v-row
          class="search-results-div"
          v-show="has_search_query == true && search_results.length > 0"
        >
          <v-col
            cols="6"
            v-for="(business, index) in search_results"
            :key="index"
          >
            <div
              class="search-result-business-div elevation-5 d-flex flex-column justify-space-between pointer"
              @click="view_business(business)"
            >
              <v-img
                :src="business.banner"
                cover
                :height="235"
                :min-height="235"
                :max-width="460"
              >
              </v-img>
              <div class="redx d-flex justify-space-between">
                <!-- .rounded-b-xl -->
                <div class="yellowx pa-2">
                  <v-img
                    :src="business.logo"
                    :height="100"
                    :min-height="100"
                    :min-width="100"
                    :width="100"
                    :max-width="100"
                  >
                  </v-img>
                </div>
                <div
                  class="greenx flex-grow-1 d-flex flex-column justify-space-between pa-2 pl-0"
                >
                  <div
                    class="search-business-name-div primary--text text-left pt-2 pl-2"
                  >
                    {{ business.name }}
                  </div>
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <v-chip
                        x-small
                        label
                        class="white--text ml-2"
                        :color="business.open_btn.color"
                        ><b class="">
                          {{ business.open_btn.open_status }}</b
                        ></v-chip
                      >
                    </div>
                    <div class="search-business-loc-div">
                      <v-icon small>mdi-map-marker</v-icon>
                      {{ business.physical_address }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between align-center redx">
                    <v-rating
                      background-color="warning lighten-1"
                      color="warning"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      half-icon="mdi-star-half-full"
                      hover
                      length="5"
                      size="18"
                      :value="parseFloat(business.rating)"
                      :readonly="true"
                      small
                    ></v-rating>
                    <v-btn
                      x-small
                      outlined
                      color="success"
                      :disabled="is_loading"
                    >
                      <v-icon left>mdi-eye</v-icon>
                      view Details ...
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row
          class="search-results-div"
          v-show="
            has_search_query == true &&
            search_results.length == 0 &&
            is_loading == false
          "
        >
          <v-col> 
            //nyd  <br/>
            No results found emogi 
          </v-col>
        </v-row>
        <v-row
          class="search-results-div"
          v-show="
            has_search_query == true &&
            search_results.length == 0 &&
            is_loading == true
          "
        >
          <v-col> 
             &nbsp;
             <!-- nothing  -->
             </v-col>
        </v-row>
        <v-row class="search-results-div" v-show="has_search_query == false">
          <v-col> 
            //nyd <br/>
            Please enter a search term 
          </v-col>
        </v-row>
      </CardedDisplay>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterSearchForm from "./../../components/CenterSearchForm";
import CardedDisplay from "./../../components/CardedDisplay";
import PlainDisplay from "./../../components/PlainDisplay";
import Footer from "./../../components/CenterFooter";
import page_info from "../../lib/page_info";
import Utils from "../../lib/Utils";
import ServerClient from '../../lib/ServerClient';
export default {
  name: "Search",
  components: {
    Page,
    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterSearchForm,
    CardedDisplay,
    PlainDisplay,
    Footer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      page: "search",
      quick_links: [],
      page_info: page_info,
      search_results: [],
      holidays: [],
      has_loaded_dependencies: false,
      has_search_query: true,
      // image_link: require("../../assets/login_bg.png"),
      // logo_link: require("../../assets/logo_vue.png"),
    };
  },
  methods: {
    load_dependencies(res) {
      var vm = this;
      vm.$emit("on-show-loader");
      ServerClient.Holidays.get_holidays({},(res_holidays) => {
        vm.$emit("on-hide-loader");
        this.holidays = res_holidays;
        vm.has_loaded_dependencies = true;
        vm.on_render_results(res);
      }, (errors) => {
        vm.$emit("on-hide-loader");
        console.log("Errors loading search holidays ", errors);
        vm.has_loaded_dependencies = true;
        vm.on_render_results(res);
      });
    },
    on_render_results(res) {
      if (this.holidays.length == 0 && this.has_loaded_dependencies == false) {
        this.load_dependencies(res);
      } else {
        //preprocess businesses
        var results = res.results;
        for (var index = 0; index < results.length; index++) {
          var business = results[index];
          // business.logo = this.logo_link;
          // business.banner = this.image_link;
          if (business.banner.length == 0) {
            business.banner = Utils.default_business_banner;
          }
          if (business.name.length > 57) {
            business.name = business.name.substring(0, 57) + " ...";
          }
          business.open_btn = Utils.set_is_business_open(
            business,
            this.holidays
          );
          results[index] = business;
        }
        this.has_search_query = true;

        this.search_results = [];
        this.search_results = results;
        this.scroll_to_secton("top_of_results");
      }
    },
    view_business(business) {
      this.$router.push("/businesses/" + business.id);
    },
    scroll_to_secton(lmnt_id) {
      var vm = this;
      try {
        setTimeout(() => {
          var options = {
            offset: 125,
            duration: 1000,
            easing: "easeInOutCubic",
          };
          vm.$vuetify.goTo("#" + lmnt_id, options);
        }, 2000);
      } catch (error) {
        console.log(
          "Error scrolling to section on directory page ",
          error,
          lmnt_id
        );
      }
    },
    on_has_no_search_query() {
      this.has_search_query = false;
    },
  },
  mounted() {
    this.has_loaded_dependencies = false;
  },
};
</script>